subscription ContentStatusChanged($id: ID!) {
  contentStatusChanged(id: $id) {
    id
    processingStatus
    transcodingError
    duration
    video {
      id
      uid
      fileName
      readyToStream
      duration
      transcodingError
    }
    pendingVideo {
      id
      uid
      fileName
    }
  }
}
